var _desc, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "44px",
    viewBox: "0 0 22 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_spent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send-A-Message-V5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25-Control-Groups",
    transform: "translate(-1083.000000, -491.000000)",
    fill: "#495462",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1099.49141,513.283594 L1089.33359,510.095312 C1087.22813,509.433594 1085.75,507.242188 1085.75,504.775781 C1085.75,501.725 1087.95,499.25 1090.64844,499.25 L1096.99062,499.25 C1098.89844,499.25 1100.71172,499.989062 1102.15547,501.355469 C1102.42188,501.604687 1102.82578,501.630469 1103.10078,501.38125 L1104.12344,500.453125 C1104.41562,500.186719 1104.43281,499.73125 1104.15781,499.45625 C1102.19844,497.565625 1099.62891,496.491406 1096.99922,496.491406 L1095.375,496.491406 L1095.375,491.6875 C1095.375,491.309375 1095.06562,491 1094.6875,491 L1093.3125,491 C1092.93438,491 1092.625,491.309375 1092.625,491.6875 L1092.625,496.5 L1090.64844,496.5 C1086.42891,496.5 1083,500.2125 1083,504.775781 C1083,508.436719 1085.26875,511.702344 1088.50859,512.716406 L1098.66641,515.904687 C1100.78047,516.566406 1102.25,518.757812 1102.25,521.224219 C1102.25,524.266406 1100.05,526.75 1097.35156,526.75 L1091.00938,526.75 C1089.10156,526.75 1087.28828,526.010937 1085.84453,524.644531 C1085.57812,524.395312 1085.17422,524.369531 1084.89922,524.61875 L1083.88516,525.546875 C1083.60156,525.804687 1083.57578,526.26875 1083.85938,526.535156 C1085.81875,528.425781 1088.38828,529.5 1091.01797,529.5 L1092.625,529.5 L1092.625,534.3125 C1092.625,534.690625 1092.93438,535 1093.3125,535 L1094.6875,535 C1095.06562,535 1095.375,534.690625 1095.375,534.3125 L1095.375,529.5 L1097.35156,529.5 C1101.57109,529.5 1105,525.7875 1105,521.224219 C1105,517.571875 1102.73125,514.30625 1099.49141,513.283594 Z",
    id: "ic_spent"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpend);
export default __webpack_public_path__ + "static/media/spend.8d3258c681bc1e88432a8352d398184a.svg";
export { ForwardRef as ReactComponent };